module.exports = __webpack_public_path__ + "static/media/porque_conlicitacao.75a88878.png";